import React from 'react'
import { inject, observer } from 'mobx-react'

import Columns from '../../../generic/Columns'
import Column from '../../../generic/Column'
import Title from '../../../generic/Title'
import Button from '../../../generic/Button'

const ConfigGroupsPageHeader = inject('configGroupsStore')(observer(props => {
  const { configGroupsStore } = props
  return (
    <Columns>
      <Column size='6'>
        <Title>Configurar Grupos</Title>
      </Column>
      <Column className='has-text-right' size='6'>
        <Button fieldData={{
          text: 'Criar grupo',
          onClick: () => configGroupsStore.openCreateGroupModal()
        }} />
      </Column>
    </Columns>
  )
}))

export default ConfigGroupsPageHeader



// WEBPACK FOOTER //
// ./src/components/dashboard/config/groups/ConfigGroupsPageHeader.js